import { useMutation } from 'react-query';

import { TRIAL_SIGNUP_QUERY_KEYS } from '../constants';
import {
  validateTrialEmail,
  type ValidateTrialEmailResponse,
} from '../request';

type ValidateTrialEmailVariables = {
  email: string;
  signal?: AbortSignal;
};

export const useValidateTrialEmailMutation = () =>
  useMutation<ValidateTrialEmailResponse, Error, ValidateTrialEmailVariables>(
    [TRIAL_SIGNUP_QUERY_KEYS.VALIDATE_EMAIL],
    ({ email, signal }: ValidateTrialEmailVariables) =>
      validateTrialEmail(email, signal)
  );
